import React from 'react';
import { getScoreColor } from '../../tokens';

const ScoreIndicator = ({ score, size = 'normal' }) => {
  const getColor = (s) => getScoreColor(s);
  const dimensions = size === 'large' ? { width: 80, height: 80, font: 24 } : { width: 44, height: 44, font: 14 };
  return (
    <div style={{
      width: dimensions.width,
      height: dimensions.height,
      borderRadius: '50%',
      backgroundColor: getColor(score),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontWeight: '700',
      fontSize: dimensions.font,
      boxShadow: `0 0 20px ${getColor(score)}40`
    }}>
      {score}
    </div>
  );
};

export default ScoreIndicator;
